import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {ORDER_SORT_OPTIONS} from '../../services/orderQueryService';
import {
  setHideDeclinedOrders
} from '../../services/orderVisibilityPreferences';

const {FiFilter,FiSearch,FiArrowUpDown}=FiIcons;

const STATUSES=['all','pending','accepted','preparing','ready','completed','cancelled'];

const SellerOrderControls=({
  search,
  setSearch,
  filter,
  setFilter,
  sort,
  setSort,
  userId,
  hideDeclined=false,
  setHideDeclined=()=>{}
})=> (
  <div className="space-y-4 mb-8">
    <div className="relative">
      <SafeIcon
        icon={FiSearch}
        className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300 text-xl"
      />
      <input
        type="search"
        value={search}
        onChange={(event)=> setSearch(event.target.value)}
        placeholder="Search customers, items, or order IDs..."
        className="w-full pl-14 pr-6 py-5 bg-white rounded-2xl border border-slate-100 shadow-sm focus:ring-4 focus:ring-indigo-500/10 outline-none font-bold placeholder-slate-300"
      />
    </div>

    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-2 bg-white rounded-2xl border border-slate-100 shadow-sm p-2">
        <SafeIcon
          icon={FiFilter}
          className="ml-2 text-slate-300 flex-shrink-0"
        />

        {STATUSES.map((status)=> (
          <button
            key={status}
            type="button"
            onClick={()=> setFilter(status)}
            className={`px-4 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap ${
              filter===status
                ? 'bg-slate-900 text-white'
                : 'text-slate-400 hover:bg-slate-50'
            }`}
          >
            {status}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap items-center gap-4">
        <label className="flex items-center gap-3 bg-white rounded-2xl border border-slate-100 shadow-sm px-4 py-3 w-fit">
          <input
            type="checkbox"
            checked={hideDeclined}
            onChange={(event)=>{
              const nextValue=event.target.checked;
              setHideDeclined(nextValue);
              setHideDeclinedOrders(userId,nextValue);
            }}
            className="h-4 w-4 accent-indigo-600"
          />
          <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest whitespace-nowrap">
            Hide declined orders
          </span>
        </label>

        <label className="flex items-center gap-3 bg-white rounded-2xl border border-slate-100 shadow-sm px-4 py-3 w-fit">
          <SafeIcon icon={FiArrowUpDown} className="text-indigo-500" />
          <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest whitespace-nowrap">
            Arrange
          </span>
          <select
            value={sort}
            onChange={(event)=> setSort(event.target.value)}
            className="bg-transparent border-none outline-none text-xs font-black text-slate-700 pr-2"
          >
            {ORDER_SORT_OPTIONS.map((option)=> (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  </div>
);

export default SellerOrderControls;
